<script lang="ts">export let league;
export let tricode;
export let lang;
</script>

<svelte:head>
  <style>
    @font-face {
			font-family: 'PJL Sans';
			src: url('/static/fonts/PJLSans/PJLSans-Regular.woff2') format('woff2');
			font-weight: normal;
			font-style: normal;
			font-display: swap;
		}

		@font-face {
			font-family: 'PJL Sans';
			src: url('/static/fonts/PJLSans/PJLSans-Bold.woff2') format('woff2');
			font-weight: 700;
			font-style: normal;
			font-display: swap;
		}</style>
</svelte:head>
